import { processCompanySize } from '../utils';

export default class NavigationService {
  /* @ngInject */
  constructor($state, DataService, ProductLinkService) {
    this.$state = $state;
    this.DataService = DataService;
    this.searchLinkIsFromProductPage = ProductLinkService.getProductLinkVerification();
  }
  navigateToSearchScreen() {
    this.$state
      .go('root.search');
  }

  navigateToErrorScreen(errorStateToNavigateTo) {
    if (errorStateToNavigateTo) {
      this.$state
        .go(errorStateToNavigateTo, null, {
          location: 'replace'
        });
    } else {
      this.$state
        .go('error', null, {
          location: 'replace'
        });
    }
  }

  navigateToContactSuccess(id) {
    this.$state
      .go('root.contact-success', { id });
  }

  navigateToSearchResults() {
    const data = this.DataService.getData();
    let companySize;

    if (data.myCompanySize) {
      companySize = processCompanySize(data.myCompanySize);
    }

    const paramsObjectToSend = {
      solutions: Object.keys(data.solutions),
      industry: data.myIndustry,
      fteFrom: companySize && companySize[0],
      fteTo: companySize && companySize[1],
      postcode: data.postCode,
      location: data.myLocation
    };

    if (this.searchLinkIsFromProductPage) {
      paramsObjectToSend.isProductLink = true;
    }

    this
      .$state
      .go('root.results', paramsObjectToSend);
  }

  navigateToDirectLinkageSearchResults(solutions) {
    const paramsObjectToSend = {
      solutions,
      isProductLink: true
    };

    this.$state
      .go('root.results', paramsObjectToSend);
  }
}




// WEBPACK FOOTER //
// ./src/services/navigation.service.js